<template>

    <div class="forum-nav-box">
        <div class="nav-title">
            <p>版块分类</p>
        </div>
        <div class="nav-menu-box">
            <ul class="nav-list">
                <li class="list-item"
                    @mouseenter="handleMenuMouseEnter(index, menu)"
                    @mouseleave="handleMenuMouseLeave(index, menu)"
                    v-for="(menu, index) in menuList"
                    :key="menu.category + index">
                    <p class="item-title">{{ menu.category }}</p>
                    <div class="nav-sub-list"
                         v-if="curIndex === index">
                        <p class="nav-title">{{ curCategory }}</p>
                        <div v-if="curDepartments && curDepartments.length !== 0"
                             class="nav-item-list">
                            <el-radio-group
                                    @change="handleRadioChange"
                                    v-model="curRadioVal"
                                    size="medium">
                                <el-radio-button
                                        v-for="ksItem in curDepartments"
                                        :label="ksItem.id"
                                        :key="curCategory + ksItem.id + ksItem.label"
                                >
                                    <el-tooltip
                                            placement="right"
                                            :content="ksItem.label"
                                            v-if="ksItem.label.length > 5">
                                        <span>{{ ksItem.label }}</span>
                                    </el-tooltip>
                                    <span v-else>{{ ksItem.label }}</span>
                                </el-radio-button>
                            </el-radio-group>
                        </div>
                        <div class="nav-item-list"
                             v-else-if="index === 0 && curDepartments && curDepartments.length === 0">
                            <p>您还没有关注版块哟，赶紧关注吧……</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

</template>

<script>

    export default {
        name: 'ForumNav',
        props: {
            menuList: {
                type: Array,
                default: () => {
                    return [];
                },
            },
        },
        data() {

            return {
                ksRadioId: '',
                curIndex: '',
                curCategory: '',
                curDepartments: [],
                curRadioVal: '',
            }
        },

        methods: {

            handleRadioChange (deptId) {
                console.log(deptId);
                this.$emit('select', deptId, this.curIndex, async () => {
                    setTimeout(() => {
                        this.curIndex = '';
                        this.curRadioVal = '';
                    }, 500)
                });
            },

            handleMenuMouseEnter (index, menu) {
                this.curIndex = index;
                this.curCategory = this.menuList[index].category;
                this.curDepartments = this.menuList[index].departments;
            },

            handleMenuMouseLeave (index, menu) {
                this.curIndex = '';
                this.curCategory = '';
                this.curRadioVal = '';
                this.curDepartments = [];
            },

        },

        created() {

        },

        mounted() {

        }
    }
</script>

<style lang="less" scoped>

    .forum-nav-box {
        color: #333;
        font-size: 14px;
        width: 200px;

        * {
            padding: 0;
            margin: 0;
        }

        .nav-title {
            padding: 15px 0;
            margin: 0 15px;
            text-align: center;
            border-bottom: 1px solid #DCDFE6;
            color: #888787;
        }

        .nav-menu-box {
            margin-top: 15px;

            ul li {
                list-style-type: none;
                height: 20px;
                padding: 15px 0;
                position: relative;
            }

            ul li:hover {
                background-color: #1DAABA;
                color: #FFF;
            }

            ul li.list-item:hover .nav-sub-list {
                z-index: 999;
            }

            .nav-list {

                p {
                    text-align: center;
                }

                .list-item {

                    .nav-sub-list {
                        width: 400px;
                        height: 250px;
                        position: absolute;
                        top: 0;
                        left: 200px;
                        background-color: #FFF;
                        box-shadow:0px 3px 16px 0px rgba(205,205,205,0.5);

                        p.nav-title {
                            text-align: left;
                        }

                        div.nav-item-list {
                            margin: 10px 15px;
                            height: 180px;
                            overflow: auto;

                            p {
                                color: #CDCDCD;
                                text-align: left;
                                margin-top: 5px;
                            }
                        }
                    }
                }
            }
        }

    }

</style>

<style lang="less">

    .forum-nav-box {

        .nav-title {

        }

        .nav-menu-box {
            .nav-sub-list {

                .nav-item-list {
                    .el-radio-button:first-child .el-radio-button__inner {
                        border-radius: 4px;
                    }

                    .el-radio-button--medium .el-radio-button__inner {
                        width: 88px;
                        padding: 10px 5px;
                        font-size: 12px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        margin: 10px 6px;
                        border: 1px solid #DCDFE6;
                        border-radius: 4px;
                    }
                    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        background-color: #1DAABA;
                        border-color: #1DAABA;
                        box-shadow: -1px 0 0 0 #1DAABA;
                        color: #FFF;
                    }

                    .el-radio-button__inner:hover {
                        color: #1DAABA;
                    }

                }
            }
        }

    }
</style>
